import { createComponent } from '@carvana/merch-components';

export const InnerWrapper = createComponent('div', {
  className: 'flex w-full flex-col items-start gap-16 m:gap-24'
});

export const SectionTitle = createComponent('h2', {
  className: 'tl-header-m l:tl-header-xl'
});

export const GridWrapper = createComponent('div', {
  className:
    'grid w-full grid-cols-1 gap-8 sm:grid-cols-2 m:grid-cols-3 m:gap-24 l:grid-cols-5'
});

export const FeatureCard = createComponent('div', {
  className:
    'flex w-full items-center justify-start gap-4 rounded-md bg-white px-8 py-12 sm:flex-col sm:py-16 sm:text-center'
});

export const FeatureIcon = createComponent('div', {
  className: 'ml-8 mr-16 sm:ml-0 sm:mr-0'
});

export const FeatureLabel = createComponent('span', {
  className: 'w-full text-blue-6 tl-body-s m:tl-body-m'
});
